import { ILocation } from "@sp-crm/core";
import { MapMarkerId } from "components/community-search/community-map/types";
import { mapLib } from "components/map/map-lib";
import "maplibre-gl/dist/maplibre-gl.css";
import * as React from "react";
import Map, { NavigationControl, ScaleControl } from "react-map-gl/maplibre";
import { NextgenMapMarker } from "../community-search/community-map/nextgen-marker";
import { useMapScaleUnit } from "./map-common";
import { MapErrorBoundary } from "./map-error-boundary";
import { MapMountTracker, MapSurface, useMapLoadTracking } from "./map-load-tracking";
import { MarkerIconColor } from "./types";
import { useBasemap } from "./use-map-style";

interface NextgenEntityMapProps {
    entityId: MapMarkerId;
    location: ILocation | null;
    iconType: MarkerIconColor;
    zoom: number;
    surface: MapSurface;
}

export const NextgenEntityMap: React.FC<NextgenEntityMapProps> = props => {
    const { location, entityId, iconType, zoom, surface } = props;
    const basemap = useBasemap("allowThirdPartyFallback");
    const tracking = useMapLoadTracking(surface, basemap);
    const scaleUnit = useMapScaleUnit();
    const mapStyleResult = basemap.result;

    if (!location || mapStyleResult.status !== "ready") {
        return <span />;
    }

    const mapStyle = mapStyleResult.style;

    return (
        <MapErrorBoundary>
            <div style={{ position: "relative", height: 200 }}>
                <Map
                    mapLib={mapLib}
                    onLoad={tracking.onLoad}
                    onError={tracking.onError}
                    attributionControl={false}
                    initialViewState={{
                        longitude: location.loc[0],
                        latitude: location.loc[1],
                        zoom,
                    }}
                    style={{ height: 200 }}
                    mapStyle={mapStyle}>
                    <MapMountTracker tracking={tracking} />
                    <NavigationControl position="top-left" />
                    <ScaleControl unit={scaleUnit} />
                    <NextgenMapMarker
                        id={entityId}
                        isHovered={false}
                        iconType={iconType}
                        location={location}
                    />
                </Map>
            </div>
        </MapErrorBoundary>
    );
};
